module.exports = __webpack_public_path__ + "media/images/icons/check-355d03d18de84adc3c00d5f948fb5bac.svg";